/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, December 9th 2022, 1:11:13 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { useWorkflowContext } from "service-builder/providers";
import { AlertSnackBar } from "ui-widgets";

export const NewTaskTemplateAddedNotification = () => {
  const [showNotification, setShowNotification] = React.useState(false);
  const previousCount = React.useRef(0);

  const {
    taskTemplateListContext: {
      itemsListState: { savedItems },
    },
  } = useWorkflowContext();

  React.useEffect(() => {
    if (previousCount.current > 0 && previousCount.current < savedItems?.length) {
      setShowNotification(true);
    }

    previousCount.current = savedItems?.length;
  }, [savedItems?.length]);

  return (
    <AlertSnackBar
      open={showNotification}
      message={<>A new task node has been added to your workflow.</>}
      vertical="top"
      horizontal="center"
      handleClose={() => setShowNotification(false)}
      autoClose
      severity="success"
    />
  );
};
